type CheckForUpdateResult = overwolf.extensions.CheckForUpdateResult;
type UpdateExtensionResult = overwolf.extensions.UpdateExtensionResult;

// -----------------------------------------------------------------------------
export class OWExtension {
  private _manifest: overwolf.extensions.Manifest;

  // ---------------------------------------------------------------------------
  public static async fromCurrent(): Promise<OWExtension> {
    return new Promise((resolve) => {
      overwolf.extensions.current.getManifest((manifest) => {
        return resolve(
          new OWExtension(manifest as overwolf.extensions.Manifest),
        );
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static async fromExtensionId(
    extensionId: string,
  ): Promise<OWExtension> {
    return new Promise((resolve) => {
      overwolf.extensions.getManifest(extensionId, (manifestResult) => {
        if (manifestResult.success) {
          resolve(
            new OWExtension(manifestResult as overwolf.extensions.Manifest),
          );
        } else {
          console.log(`${extensionId} - ${JSON.stringify(manifestResult)}`);
          resolve(null);
        }
      });
    });
  }

  public static async generateUserEmailHashes(
    email: string,
  ): Promise<boolean> {
    return new Promise((resolve) => {
      overwolf.extensions.current.generateUserEmailHashes(email, (result) => {
        return resolve(result.success);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static CheckForUpdate(): Promise<CheckForUpdateResult> {
    return new Promise((resolve) => {
      overwolf.extensions.checkForExtensionUpdate(resolve);
    });
  }

  public static RepairUrlProtocol(): Promise<boolean> {
    return new Promise((resolve) => {
      overwolf.extensions.current.repairUrlProtocol((result) => {
        return resolve(result.success);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static UpdateExtension(): Promise<UpdateExtensionResult> {
    return new Promise((resolve) => {
      overwolf.extensions.updateExtension(resolve);
    });
  }

  // ---------------------------------------------------------------------------
  private constructor(manifest: overwolf.extensions.Manifest) {
    this._manifest = manifest;
  }

  // ---------------------------------------------------------------------------
  public get manifest(): overwolf.extensions.Manifest {
    return this._manifest;
  }
}
